import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/request-password-reset`, { email });
      setSent(true);
      toast.success('Revisa tu correo electrónico');
    } catch {
      toast.error('Error al enviar, intenta de nuevo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #F8FAF6 0%, #EDF2E8 50%, #F0F4EC 100%)' }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="https://customer-assets.emergentagent.com/job_nutrifit-portal/artifacts/s4srivcq_Logo%20Icono%20Solo%20Nutriquimia%20SVG.svg" alt="Nutriquimia" className="h-14 mx-auto mb-3" />
          <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Nutriquimia</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl shadow-black/[0.06] p-7">
          {!sent ? (
            <>
              <h2 className="text-xl font-bold text-gray-900 text-center mb-0.5" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                Recuperar Contraseña
              </h2>
              <p className="text-xs text-gray-400 text-center mb-6">
                Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña
              </p>

              <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
                <div>
                  <Label className="text-[11px] text-gray-400 font-semibold mb-1 block">Correo Electrónico</Label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={15} />
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="correo@ejemplo.com"
                      required
                      autoComplete="off"
                      className="h-11 pl-9 bg-gray-50/80 border border-gray-200/60 focus:border-[#467322] focus:ring-1 focus:ring-[#467322]/15 rounded-xl text-sm"
                      data-testid="reset-email-input"
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  disabled={loading}
                  className="w-full h-11 text-white text-sm font-bold rounded-xl transition-all duration-300 hover:-translate-y-0.5 group"
                  style={{ background: '#467322' }}
                  data-testid="reset-submit-btn"
                >
                  {loading ? 'Enviando...' : 'Enviar enlace'}
                  {!loading && <ArrowRight size={15} className="ml-1.5 group-hover:translate-x-1 transition-transform" />}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center py-4" data-testid="reset-sent-message">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Mail size={28} className="text-emerald-500" />
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                Revisa tu correo
              </h2>
              <p className="text-sm text-gray-500 mb-1">
                Hemos enviado un enlace de recuperación a:
              </p>
              <p className="text-sm font-bold text-gray-800 mb-4">{email}</p>
              <p className="text-xs text-gray-400">El enlace expira en 1 hora. Si no lo ves, revisa tu carpeta de spam.</p>
            </div>
          )}
        </div>

        <p className="text-xs text-gray-400 text-center mt-6">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="font-bold hover:underline flex items-center justify-center gap-1 mx-auto"
            style={{ color: '#467322' }}
            data-testid="back-to-login"
          >
            <ArrowLeft size={12} /> Volver a Iniciar Sesión
          </button>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
